export default "__VITE_ASSET__CYff01PK__"